import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ViewListProps = IconComponentBaseProps;

export const ViewList = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: ViewListProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_9027_32726"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9027_32726)">
        <path
          d="M3.5 16.4952V7.37024C3.5 6.86824 3.677 6.44066 4.031 6.08749C4.385 5.73432 4.81058 5.55774 5.30775 5.55774H18.6923C19.1894 5.55774 19.615 5.73432 19.969 6.08749C20.323 6.44066 20.5 6.86824 20.5 7.37024V16.4952C20.5 16.9971 20.323 17.4246 19.969 17.7777C19.615 18.1311 19.1894 18.3077 18.6923 18.3077H5.30775C4.81058 18.3077 4.385 18.1311 4.031 17.7777C3.677 17.4246 3.5 16.9971 3.5 16.4952ZM5 9.30774H7.25V7.05774H5.30775C5.21792 7.05774 5.14417 7.08657 5.0865 7.14424C5.02883 7.20191 5 7.27566 5 7.36549V9.30774ZM8.75 9.30774H19V7.36549C19 7.27566 18.9712 7.20191 18.9135 7.14424C18.8558 7.08657 18.7821 7.05774 18.6923 7.05774H8.75V9.30774ZM8.75 13.0577H19V10.8077H8.75V13.0577ZM8.75 16.8077H18.6923C18.7821 16.8077 18.8558 16.7789 18.9135 16.7212C18.9712 16.6634 19 16.5897 19 16.5V14.5577H8.75V16.8077ZM5.30775 16.8077H7.25V14.5577H5V16.5C5 16.5897 5.02883 16.6634 5.0865 16.7212C5.14417 16.7789 5.21792 16.8077 5.30775 16.8077ZM5 13.0577H7.25V10.8077H5V13.0577Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
